<template>
  <BaseLink :href="href">
    <BaseImage v-bind="containerStyle"
               v-on="$listeners"
               :imageStyle="imageStyle"
               :src="src" />
  </BaseLink>
</template>

<script>
  import BaseImage from '@base/base-image'
  import BaseLink from '@base/base-link'

  export default {
    name: 'ImagePrimary',
    inheritAttrs: false,
    components: {
      BaseImage,
      BaseLink,
    },
    props: {
      height: { type: String, required: false, default: 'none' },
      href: { type: String, required: false, default: () => null },
      routeName: { type: String, required: false, default: () => null },
      src: { type: String, required: false, default: '//:0' },
      width: { type: String, required: false, default: 'none' },
    },
    data: function () {
      return {
        containerStyle: {
          height: this.height,
          width: this.width,
        },
        imageStyle: {
          cursor: this.href ? 'pointer' : (this.routeName ? 'pointer' : 'default'),
          objectFit: 'cover',
        },
      };
    },
    created: function () {
      this.containerStyle = {
        ...this.containerStyle,
        ...this.$attrs,
      };
    },
  };
</script>
